export default "__VITE_ASSET__B6zplBa6__"